<template>
  <div>
    <Schedule
      :id="id"
      :fields="fields"
      :data="data"
      :code="code"
      :config="config"
    />
  </div>
</template>

<script>
import { Schedule } from "@ocs-software/vue-ocs";
export default {
  name: "Sced First Table",
  props: ["id", "fields", "data", 'code', 'config'],
  components: {
    Schedule
  },
  filters: {
    base: function(value) {
      return btoa(value);
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (this.code === item.code) return 'live'
    }
  }
};
</script>

<style scoped>
::v-deep .major {
  color: #1A2337!important;
  font-weight: bold!important;
}
::v-deep .major > a {
  color: #1A2337!important;
  font-weight: bold!important;
}
li{
  list-style: none;
}
.nav-link {
  color: #222629;
}
::v-deep th {
  position: sticky;
  top: 0;
  background-color: #263056;
  z-index: 111;
}

::v-deep .live{
  color: white;
  background-color: #1A2337 !important;
}
::v-deep .live>td>li>a{
  color: white!important;
}
::v-deep .live>td>span{
  color: white!important;
}
::v-deep .live>td>ul>div>button{
  border: 0;
}
@media only screen and (max-width: 768px) {
  td.scheduleNav > li > a {
    font-size: 9pt;
  }
  ::v-deep td.scheduleNav {
    font-size: 9pt!important;
  }
  ::v-deep .btn {
    background-color: #CC444A;
    border-color: white;
    font-size: 9pt;
    border-radius: 0;
    width: 100%;
  }
}
</style>
<style scoped src="@/css/schedule.css"></style>